import { Component, Input, OnInit } from '@angular/core';
import { Transport, TransportTaskStatus } from '../../../../../../common/model/transport.model';

@Component({
  selector: 'app-planned-assignment-list-entry',
  templateUrl: './planned-assignment-list-entry.component.html',
  styleUrls: ['./planned-assignment-list-entry.component.scss']
})
export class PlannedAssignmentListEntryComponent implements OnInit {

  @Input()
  transportDetails: Transport;

  TransportTaskStatus = TransportTaskStatus;

  @Input()
  selected: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
